import React from "react";
import { ArrowRight, TrendingUp, ShieldCheck, Activity } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function GrowthCapitalMandate() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="growth-capital-mandate" className="dark bg-background text-foreground relative min-h-[90vh] flex items-center justify-center overflow-hidden py-24">
      {}
      <div className="absolute inset-0 bg-[#050505] z-0"></div>

      {}
      <div className="absolute inset-0 z-0 opacity-[0.04] pointer-events-none" style={{
      backgroundImage: `
            linear-gradient(to right, #ffffff 1px, transparent 1px),
            linear-gradient(to bottom, #ffffff 1px, transparent 1px)
          `,
      backgroundSize: '60px 60px'
    }} />

      {}
      <div className="absolute inset-0 z-0 bg-[radial-gradient(circle_at_50%_50%,transparent_10%,#050505_90%)] pointer-events-none"></div>

      {}
      <div ref={ref} className={cn("relative z-10 container mx-auto px-4 md:px-8 max-w-6xl flex flex-col items-center text-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        {}
        <div className="mb-10 flex items-center gap-3 border-b border-border/20 pb-3">
            <span className="text-[10px] md:text-xs font-mono uppercase tracking-[0.25em] text-muted-foreground">
                Dynestate Capital Mandate
            </span>
            <div className="h-px w-12 bg-primary/40"></div>
            <span className="text-[10px] md:text-xs font-mono uppercase tracking-[0.25em] text-primary flex items-center gap-2">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
                </span>
                Active
            </span>
        </div>

        {}
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif font-medium tracking-tight text-foreground mb-8 leading-[0.95]">
          Business Growth <br />
          <span className="text-muted-foreground font-light italic">& Private Credit</span>
        </h1>

        {}
        <p className="text-lg md:text-xl text-muted-foreground/80 max-w-2xl mx-auto mb-12 font-light leading-relaxed tracking-wide"><span className="text-foreground font-normal" data-ast-id="f:/src/pages/BusinessCapital/sections/GrowthCapitalMandate.tsx|sig:wouier" data-ast-start="2624" data-ast-end="2849">Strategic Liquidity. Execution Excellence.</span><br />We provide structured capital solutions for complex business needs, ensuring speed and certainty in an evolving market. We also have specialty capital programs that include: Start-up Capital, Unsecured Funding Programs, Industry-Specific Funding, Nonprofit Line of Credit, Credit Enhancement / Tradelines, Debt Consolidation / Refinance</p>

        {}
        <div className="flex flex-col sm:flex-row items-center gap-5 w-full sm:w-auto mb-20">
          <Button asChild className="h-14 px-10 rounded-none bg-foreground text-background hover:bg-foreground/90 text-base font-medium tracking-wide min-w-[220px] shadow-[0_0_20px_rgba(255,255,255,0.1)]">
            <Link to="/ContactPage">
              Request Capital
              <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </Button>

          <Button asChild variant="outline" className="h-14 px-10 rounded-none border-border/30 text-foreground hover:bg-white/5 hover:border-foreground/50 text-base font-medium tracking-wide min-w-[220px]">
            <Link to="/BusinessCapitalPage">
              Explore Solutions
            </Link>
          </Button>
        </div>

        {}
        <div className="w-full border-t border-border/10 pt-10 grid grid-cols-2 md:grid-cols-4 gap-8 text-left">
            <div className="flex flex-col border-l border-border/10 pl-6">
                <div className="flex items-center gap-2 mb-2 text-muted-foreground">
                    <Activity className="w-4 h-4" />
                    <span className="text-xs font-mono uppercase tracking-wider">Liquidity Focus</span>
                </div>
                <span className="text-lg font-serif text-foreground">Senior & Mezzanine</span>
            </div>
            <div className="flex flex-col border-l border-border/10 pl-6">
                <div className="flex items-center gap-2 mb-2 text-muted-foreground">
                    <TrendingUp className="w-4 h-4" />
                    <span className="text-xs font-mono uppercase tracking-wider">Deployment</span>
                </div>
                <span className="text-lg font-serif text-foreground">National (US)</span>
            </div>
            <div className="flex flex-col border-l border-border/10 pl-6">
                <div className="flex items-center gap-2 mb-2 text-muted-foreground">
                    <ShieldCheck className="w-4 h-4" />
                    <span className="text-xs font-mono uppercase tracking-wider">Structure</span>
                </div>
                <span className="text-lg font-serif text-foreground">Customized Credit</span>
            </div>
             <div className="flex flex-col border-l border-border/10 pl-6">
                <div className="flex items-center gap-2 mb-2 text-muted-foreground">
                    <span className="w-4 h-4 flex items-center justify-center font-serif italic">t</span>
                    <span className="text-xs font-mono uppercase tracking-wider">Speed</span>
                </div>
                <span className="text-lg font-serif text-foreground">24-48hrs Close</span>
            </div>
        </div>
      </div>
    </section>;
}